<template>
    <transition name="fade">
        <div
            class="modal"
            :class="value ? 'show' : 'hide'"
            :style="value ? 'display:block;background-color:#3333337a;' : 'display:none;'"
            tabindex="-1"
            role="dialog"
            aria-hidden="true"
        >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header d-flex flex-row align-items-center">
                    <h3>
                        {{ row_fa.fa_id ? "Éditer une question" : "Ajouter une question" }}
                    </h3>
                </div>
                <div class="modal-body">

                    <m-form-select
                        label="Catégorie"
                        label-position="top"
                        :name="$Utils.randomstring('filterCategory')"
                        v-model="row_fa.fa_category"
                        :items="$store.state.items_fa_categories"
                    />
                    <div v-if="categoryError" class="text-danger">
                        Merci de renseigner ce champ
                    </div>

                    <m-form-text 
                        :rows="4"
                        label="Question"
                        type="textarea"
                        v-model="row_fa.fa_question"
                    />
                    <div v-if="questionError" class="text-danger">
                        Merci de renseigner ce champ
                    </div>

                    <m-form-text 
                        :rows="8"
                        label="Réponse"
                        type="textarea"
                        v-model="row_fa.fa_answer"
                    />
                    <div v-if="answerError" class="text-danger">
                        Merci de renseigner ce champ
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="cancelWin">Annuler</button>
                    <button type="button" class="btn btn-primary ml-2" @click="updateQuestion">
                        {{ row_fa.fa_id ? "Mettre à jour" : "Créer" }}
                    </button>
                </div>
            </div>
        </div>
        <m-message-dialog v-model="dialogErr" title="Erreur" :text="dialogErrTxt"></m-message-dialog>
        </div>
    </transition>
</template>

<script>
export default {
    name: "questionWinEdit",

    components: {},

    props: {
        value: {
            default: false,
            type: Boolean
        },

        row_fa_p: {
            default: null,
            type: Object
        }
    },

    data() {
        return {
            row_fa: { 
                fa_id: undefined,
                fa_question: "",
                fa_answer: "",
                fa_category: 0
            },
            categoryError: false,
            questionError: false,
            answerError: false,
            dialogQuestion: false,
            dialogErrTxt: "",
            dialogErr: false
        };
    },

    mounted() {
        this.user = this.$store.state.user;
        window.addEventListener("keyup", this.onKeyup);
    },

    destroyed() {
        window.removeEventListener("keyup", this.onKeyup);
    },

    created() {},

    watch: {
        row_fa_p(value) {
            this.row_fa = value;
        }
    },

    methods: {

        onKeyup(e) {
            if (e.key === "Escape") {
                this.cancelWin();
            }
        },

        getQuestionCategory(value) {
            const result = this.$store.state.items_fa_categories.find(category => category.value === value);
            return result ? result.text : "???";
        },

        async updateQuestion() {
        
            if(!(typeof this.row_fa.fa_category === 'number')) {
                this.categoryError = true;
            } else {
                this.categoryError = false;           
            }

            if(this.row_fa.fa_question === '') {
                this.questionError = true;
            } else {
                this.questionError = false;
            }

            if(this.row_fa.fa_answer === '') {
                this.answerError = true;
            } else {
                this.answerError = false;
            }

            if(this.categoryError || this.questionError || this.answerError) {
                return;
            }

            const data = {
                fa_category: this.row_fa.fa_category,
                fa_question: this.row_fa.fa_question,
                fa_answer: this.row_fa.fa_answer,
            }

            let response;

            if(this.row_fa.fa_id) {
                response = await this.$axios.put(`${this.$config.server_url}/extranet/2.0/faq/${this.row_fa.fa_id}`, data);
            } else {
                response = await this.$axios.post(`${this.$config.server_url}/extranet/2.0/faq`, data);
            }

            if (response.data.err) {
                this.$store.dispatch("showDialogError", response.data.err.message);
                return;
            }

            this.$emit("reload", false);
            this.$emit("input", false);
        },

        cancelWin() {
            this.$emit("input", false);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "../scss/styles.scss";

    .table {
        table-layout: fixed;
    }

    .table tr:nth-child(odd) {
        background-color: inherit;
    }

    .table tr:hover {
        background-color: inherit;
        cursor: inherit;
    }

    .table tr td {
        border: 0;
    }

    .cr_label_cell {
        width: 160px;
        font-weight: 500;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin-bottom: 3px;
        padding: 2px 4px;
        width: 100%;
        cursor: pointer;
        border: 1px solid #c0c0c0;
        border-radius: 3px;
    }

    li:hover {
        background-color: #f5f5f5
    }

    pre {
        white-space: break-spaces;
    }
</style>
